import * as React from 'react'

const SvgChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6.25l6.25 6.25-.875.875L10 8l-5.375 5.375-.875-.875L10 6.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgChevronUpIcon
